import React from "react";

export const PersonOutlineIcon: React.FC<{ className?: string }> = ({
  className,
}) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M7.99996 3.93334C8.77329 3.93334 9.39996 4.56 9.39996 5.33334C9.39996 6.10667 8.77329 6.73334 7.99996 6.73334C7.22663 6.73334 6.59996 6.10667 6.59996 5.33334C6.59996 4.56 7.22663 3.93334 7.99996 3.93334ZM7.99996 9.93334C9.97996 9.93334 12.0666 10.9067 12.0666 11.3333V12.0667H3.93329V11.3333C3.93329 10.9067 6.01996 9.93334 7.99996 9.93334ZM7.99996 2.66667C6.52663 2.66667 5.33329 3.86 5.33329 5.33334C5.33329 6.80667 6.52663 8 7.99996 8C9.47329 8 10.6666 6.80667 10.6666 5.33334C10.6666 3.86 9.47329 2.66667 7.99996 2.66667ZM7.99996 8.66667C6.21996 8.66667 2.66663 9.56 2.66663 11.3333V13.3333H13.3333V11.3333C13.3333 9.56 9.77996 8.66667 7.99996 8.66667Z" />
    </svg>
  );
};
